export default function Salaries() {
  return (
    <div>
      <p>Salaries</p>
    </div>
  );
}
